import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ProductsApiService from "@/core/services/api.service.products";

export default {
  name: "products",
  data() {
    return {
      shopId: null,
      name: "",
      published: null,
      supplierCode: "",
      code: "",
      minPrice: null,
      maxPrice: null,
      description: "",
      categoryId: null,
      products: [],
      totalProducts: 0,
      totalPages: 0,
      loading: false,
      pagination: {
        page: 1,
        itemsPerPage: 10
      },
      apiInitialized: false
    };
  },
  computed: {
    pageName() {
      return "Products";
    },
    headers() {
      return [
        { text: "ID", value: "id", sortable: false, width: "5%" },
        { text: "Image", value: "thumbPath1", sortable: false, width: "8%", align: "center" },
        { text: "Name", value: "name", sortable: false, width: "25%" },
        { text: "Shop ID", value: "shopId", sortable: false, width: "8%" },
        { text: "Price", value: "price", sortable: false, width: "12%", align: "center" },
        { text: "Stock", value: "inStock", sortable: false, width: "10%", align: "center" },
        { text: "Reserved", value: "reserved", sortable: false, width: "10%", align: "center" },
        { text: "Categories", value: "categoryIds", sortable: false, width: "12%" },
        { text: "Published", value: "published", sortable: false, width: "10%", align: "center" }
      ];
    },
    headersMobile() {
      return [
        { text: "Name", value: "name", sortable: false, width: "40%" },
        { text: "Price", value: "price", sortable: false, width: "20%" },
        { text: "Stock", value: "inStock", sortable: false, width: "20%" },
        { text: "Published", value: "published", sortable: false, width: "20%" }
      ];
    },
    publishedOptions() {
      return [
        { text: "All", value: null },
        { text: "Published", value: true },
        { text: "Not Published", value: false }
      ];
    },
    activeFiltersCount() {
      let count = 0;
      if (this.shopId) count++;
      if (this.name) count++;
      if (this.published !== null) count++;
      if (this.supplierCode) count++;
      if (this.code) count++;
      if (this.minPrice !== null) count++;
      if (this.maxPrice !== null) count++;
      if (this.description) count++;
      if (this.categoryId) count++;
      return count;
    }
  },
  watch: {
    pagination: {
      handler() {
        if (this.apiInitialized) {
          this.retrieveProducts();
        }
      },
      deep: true
    }
  },
  async mounted() {
    await ProductsApiService.init();
    this.apiInitialized = true;
    this.$store.dispatch(SET_BREADCRUMB, [{ title: this.pageName }]);
    await this.retrieveProducts();
  },
  methods: {
    isMobile() {
      return window.innerWidth < 768;
    },

    getRequestParams() {
      let params = {
        page: this.pagination.page - 1,
        size: this.pagination.itemsPerPage
      };

      if (this.shopId) {
        params.shopId = this.shopId;
      }

      if (this.name) {
        params.name = this.name;
      }

      if (this.published !== null) {
        params.published = this.published;
      }

      if (this.supplierCode) {
        params.supplierCode = this.supplierCode;
      }

      if (this.code) {
        params.code = this.code;
      }

      if (this.minPrice !== null) {
        params.minPrice = this.minPrice;
      }

      if (this.maxPrice !== null) {
        params.maxPrice = this.maxPrice;
      }

      if (this.description) {
        params.description = this.description;
      }

      if (this.categoryId) {
        params.categoryId = this.categoryId;
      }

      return params;
    },

    async retrieveProducts() {
      try {
        this.loading = true;
        const params = this.getRequestParams();
        const response = await ProductsApiService.getAllProducts(params);

        this.products = response.data.items || [];
        this.totalProducts = response.data.totalNumOfItems || 0;
        this.totalPages = response.data.totalNumOfPages || 0;

        this.$store.dispatch(SET_BREADCRUMB, [
          { title: `${this.pageName}: ${this.totalProducts}` }
        ]);
      } catch (error) {
        console.error("Error fetching products:", error);
        this.$bvToast?.toast("Failed to load products", {
          variant: "danger",
          solid: true,
          autoHideDelay: 3000
        });
      } finally {
        this.loading = false;
      }
    },

    clearFilters() {
      this.shopId = null;
      this.name = "";
      this.published = null;
      this.supplierCode = "";
      this.code = "";
      this.minPrice = null;
      this.maxPrice = null;
      this.description = "";
      this.categoryId = null;
      this.retrieveProducts();
    },

    formatCategories(categoryIds) {
      if (!categoryIds) return "-";
      return categoryIds.split(",").join(", ");
    }
  }
};
